import gql from 'graphql-tag';
import ProductAttributeAllData from '../fragments/ProductAttributeAllData';

export default gql`
mutation createProductAttribute (
    $name: String!
    $code: String!
    $filterable: Boolean!
    $is_active: Boolean!
    $type: ProductAttributeType!
) {
    createProductAttribute (input: {
        name: $name
        code: $code
        filterable: $filterable
        is_active: $is_active
        type: $type
    }) {
        ...ProductAttributeAllData
    }
}
${ProductAttributeAllData}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/mutations/createProductAttribute.ts